module.exports = __webpack_public_path__ + "img/vert-6.59fbcae8.png";